<template lang="pug">
GenericCard.payment-history(size='85' :ignoreMaxWidth='true')
  .d-flex.flex-column
    .sticky-top.bg-white
      //- p {{customer}}
      .d-flex.px-4.py-4
        CustomerDetailHeader.w-100(:data='customer')
      .d-flex.blue-gradient.py-3.px-2
        NumberWithDescription(
          v-if='customer.unpaid'
          :number='customer.account.total_orders_12months'
          description='รายการสั่งซื้อ<br>ในรอบปีที่ผ่านมา'
        )
        NumberWithDescription(
          :number='customer.account.problematic_checks_recent'
          description='เช็คที่มีปัญหา<br>ในรอบ 12 เดือน'
        )
        NumberWithDescription(
          :number='customer.account.problematic_checks'
          description='เช็คที่มีปัญหา<br>ทั้งหมด'
        )
        NumberWithDescription(
          :number='customer.account.average_payment_time'
          description='ระยะเวลา<br>การชำระเงิน<br>โดยเฉลี่ย'
        )

  .sticky-top.bg-white
    .d-flex.align-items-center.justify-content-between.p-3
      .d-flex
        .text-large ประวัติการชำระเงิน
        LoadingIndicator.ml-2(v-if='isLoading')
      CustomDatePicker(v-model='filterDate')
    hr.m-0

  LoadedContentWrapper.flex-fill(
    :isLoading='isLoading'
    :data='tableData'
    @reload='loadData'
  )
    .py-2.px-3
      CustomTable(
        :columns='tableColumns'
        :data='filteredTableData'
        :showIndexes='true'
        :showNotificationDots='false'
        :itemClickable='false'
      )
    //- @itemClicked='showModal'
  //- modal(
  //-   name='sell-record'
  //-   width='90%' height='95%'
  //-   transition='modal-transition'
  //- )
  //-   SellRecordDetail(
  //-     :customer='customer'
  //-     :sellRecord='selectedItem'
  //-     @closeButtonClicked='hideModal'
  //-   )

</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerDetailHeader from '@/components/customers/CustomerDetailHeader.vue';
// import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    customer() {
      this.loadData();
    },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      return this.tableData.filter((item) => {
        return (
          (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
          // && (!this.filterStatus || item.status.toString() === this.filterStatus)
          // && (!KEYWORD || item.entryNo.toUpperCase().toString().includes(KEYWORD)));
        );
      });
    },
  },
  data() {
    return {
      // statusList: this.$api.customer.ORDER_STATUS,
      statusList: {
        0: 'รออนุมัติ',
        1: 'อนุมัติ',
        2: 'ไม่อนุมัติ',
      },
      filterStatus: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        cheque_no: {
          title: 'เลขที่เช็ค',
          align: 'left',
        },
        date_cheque: {
          title: 'ลงวันที่',
          align: 'left',
          type: Date,
        },
        bank_name: {
          title: 'ธนาคาร',
          align: 'left',
        },
        date_cheque_pickup: {
          title: 'วันที่รับ',
          align: 'right',
          type: Date,
        },
        date_cheque_receipt: {
          title: 'วันที่ได้รับเงิน',
          align: 'right',
          type: Date,
        },
        total_money: {
          title: 'ยอดเงิน',
          align: 'right',
          type: Number,
        },
      },

      selectedItem: {},
      isLoading: false,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset
      this.tableData = null;

      try {
        const res = await this.$api.billing.paymentHistory(this.customer.id);
        if (res.status === 200) {
          this.tableData = res.data.data;
          console.log(res.data.data);
        }
      } catch (e) {
        this.tableData = null;
      }

      this.isLoading = false;
    },
    // showModal(e) {
    //   this.selectedItem = e.data;
    //   this.$modal.show('sell-record');
    // },
    // hideModal() {
    //   // console.log('close');
    //   this.$modal.hide('sell-record');
    // },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerDetailHeader,
    // SellRecordDetail,
  },
};
</script>

<style lang="scss">
// .payment-history {}
</style>
